import {AxiosProcessor} from "@/shared/axios/AxiosProcessor";
const urlAssignment = '/assignment';

const state = {
    users: {}
};

const getters = {
    getUsers: state => {
        return state.users;
    }
};

const mutations = {
    setUsers: (state, data) => {
        state.users = data;
    }
};

const actions = {
    async getClientsForAssignment({commit}, data) {
        let value = {};
        let url = `${urlAssignment}/client/${data.id}?`+
        `map=${data.map == undefined ? false : data.map}`+
        `&radius=${data.radius}`+
        `&lat=${data.latitude}`+
        `&lgt=${data.longitude}`;

        let response = await AxiosProcessor.get(url);

        if(response.Items)
            value = response.Items;

        commit('setUsers', value);
    },

    async getEmployeesForAssignment({commit}, data) {
        let value = {};
        let url = `${urlAssignment}/employee/${data.id}?`+
            `map=${data.map == undefined ? false : data.map}`+
            `&radius=${data.radius}`+
            `&lat=${data.latitude}`+
            `&lgt=${data.longitude}`;

        let response = await AxiosProcessor.get(url);

        if(response.Items)
            value = response.Items;

        commit('setUsers', value);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}